import React, { Component } from "react";
import PropTypes from "prop-types";

export default class VerticalStick extends Component {
  static propTypes = {
    height: PropTypes.number,
    isEven: PropTypes.bool,
    isVisible: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  };

  static defaultProps = {
    height: 0,
    isEven: false,
    isVisible: false,
    value: 0
  };

  state = {
    animate: false
  };

  componentDidUpdate(prevProps) {
    if (this.props.isVisible && this.props.isVisible !== prevProps.isVisible) {
      this.setState(
        {
          animate: true
        },
        () => {
          setTimeout(() => {
            this.setState({
              animate: false
            });
          }, 1 * 1000);
        }
      );
    }

    if (prevProps.value !== this.props.value) {
      /* eslint-disable react/no-did-update-set-state */
      this.setState(
        {
          animate: true
        },
        () => {
          setTimeout(() => {
            this.setState({
              animate: false
            });
          }, 1 * 1000);
        }
      );
    }
  }

  render() {
    const { height, value, isEven } = this.props;
    const isLow = height < 3 ? "vertical-stick__row--low" : "";
    const gradientColor = isEven
      ? "vertical-stick__row--teal"
      : "vertical-stick__row--green";
    const isLabelSmall = isEven ? "" : "vertical-stick__value--small";

    return (
      <div className="vertical-stick">
        {value > 0 ? (
          <span className={`vertical-stick__value ${isLabelSmall}`}>
            {value}
          </span>
        ) : null}
        <div
          className={`vertical-stick__row ${isLow} ${gradientColor} ${
            this.state.animate ? "animate" : ""
          }`}
          style={{ height: `${height}%` }}
        />
      </div>
    );
  }
}
